<template>
	<div id="StarkenModalComponent">
		<div class="modal fade" id="starkenModalComponent" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Seguimiento Starken</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
                        <div class="alert" :class="'alert-' + item.status_id " role="alert">
                            {{ item.of }} <span class="float-right">{{ item.status_op }}</span>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                General
                            </div>
                            <div class="card-body">
                                <ul style="list-style-type: disc">
                                    <li>Orden: {{ item.of }}</li>
                                    <li>Fecha de Emisión: {{ item.created_at | formatDate }}</li>
                                    <li>Fecha de Compromiso: {{ item.commitmen_date | formatDate }}</li>
                                    <li>Tipo Servicio: {{ item.type_service }}</li>
                                    <li>Tipo Entrega: {{ item.type_delivery }}</li>
                                    <li>Origen: {{ item.origin }}</li>
                                </ul>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                Destino
                            </div>
                            <div class="card-body">
                                <ul style="list-style-type: disc">
                                    <li>Ciudad: {{ item.destination }}</li>
                                    <li>Destinatario: {{ item.receiver_name }}</li>
                                    <li>Dirección: {{ item.receiver_address }}</li>
                                    <li>Comuna: {{ item.destination }}</li>
                                    <li v-if="item.received_name != null">Recibido por: {{ item.received_name }}</li>
                                </ul>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                Historial
                            </div>
                            <div class="card-body">
                                <table class="table table-sm table-12">
                                    <tr v-for="(it, index) in item.history" :keys="it">
                                        <td>{{ it.created_at | formatDate }}</td>
                                        <td>{{ it.note }}</td>
                                        <td>{{ it.status }}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import mixin from '@/mixins'
	export default {
		name: 'StarkenModalComponent',
        mixins: [mixin],
        props: ['item'],
		data () {
			return {
			}
		},
		computed: {
        },
		methods: {
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .alert-origen, .alert-3 {
        color: #fff;
        background-color: #00b7bd;        
    }
    .alert-transito, .alert-6 {
        color: #fff;
        background-color: #da8c10;        
    }
    .alert-destino, .alert-7 {
        color: #fff;
        background-color: #8426a3;        
    }
    .alert-reparto, .alert-9 {
        color: #fff;
        background-color: #33b7b7;        
    }
    .alert-excepciones, .alert-10 {
        color: #fff;
        background-color: #dc5e4b;        
    }
    .alert-entregado, .alert-1 {
        color: #fff;
        background-color: #009551;        
    }
    .alert-otros, .alert-15, .alert-2 {
        color: #fff;
        background-color: #0067a4;        
    }
    .alert-redestinados, .alert-13 {
        color: #fff;
        background-color: #771243;        
    }
</style>
